var s = function () {
  return s = Object.assign || function (t) {
    for (var r, e = 1, o = arguments.length; e < o; e++) {
      r = arguments[e];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, s.apply(this, arguments);
};
export { s as __assign };